module.exports = "import React from 'react';\nimport { Bullseye } from '@patternfly/react-core';\n\nclass SimpleBullseye extends React.Component {\n  render() {\n    return (\n      <Bullseye>\n        <div>centered</div>\n      </Bullseye>\n    );\n  }\n}\n\nexport default SimpleBullseye;\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/raw-loader!../react-core/src/layouts/Bullseye/examples/SimpleBullseye.js
// module id = 456
// module chunks = 114276838955818 185097761661854